"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsListItem = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var OptionsListItem = function (_a) {
    var children = _a.children, onClick = _a.onClick;
    return (React.createElement(OptionsListItemWrapper, { style: { paddingBottom: '8px' }, onClick: function (event) {
            if (typeof onClick === 'function') {
                if (event) {
                    onClick(event);
                }
                else {
                    onClick();
                }
            }
        } }, children));
};
exports.OptionsListItem = OptionsListItem;
var OptionsListItemWrapper = styled_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  font-weight: 300;\n  padding: ", ";\n  display: flex;\n  width: 100%;\n  align-items: center;\n\n  span {\n    text-align: center;\n    display: inline-block;\n    line-height: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  font-size: ", ";\n  font-weight: 300;\n  padding: ", ";\n  display: flex;\n  width: 100%;\n  align-items: center;\n\n  span {\n    text-align: center;\n    display: inline-block;\n    line-height: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n  }\n"])), theme_1.fontSize.body, theme_1.spacing.mini, theme_1.lineHeight.body, theme_1.colors.black05);
var templateObject_1;
//# sourceMappingURL=index.js.map